export enum Role {
    Client = 'Client',
    PaymentReviewer = 'PaymentReviewer',
    PageModerator = 'PageModerator',
    SecurityKeeper = 'SecurityKeeper',
    ServerSetuper = 'ServerSetuper',
    ConnectionRegulator = 'ConnectionRegulator',
}
